import React from 'react';
import Layout from "../../components/layout/layout";
//import Cookie from "../../components/common/cookie";
import { Slider } from "../../components/layout/slider";
import AboutUsSection from "../../components/common/section/about-us-section";
import WhatWeDoSection from "../../components/common/section/what-we-do-section";
import ProductSection from "../../components/common/section/product-section";
import DocumentsSection from "../../components/common/section/document-section";

import FindDistributorSection from "../../components/common/section/find-distributor-section";
import WhyChooseUsSection from "../../components/common/section/why-choose-us-section";

const Homepage = ({siteConfig}) => {



    return (

        <Layout siteConfig={siteConfig}>
            
            <Slider siteConfig={siteConfig} />
            <AboutUsSection siteConfig={(siteConfig)}  />
            <WhatWeDoSection siteConfig={(siteConfig)}  />
            <ProductSection />
            <WhyChooseUsSection  siteConfig={(siteConfig)}  />
            <FindDistributorSection siteConfig={(siteConfig)}/>
            {/* <DocumentsSection /> */}
            <DocumentsSection />

          {/*  <Cookie />*/}

        </Layout>

  );
}


export default Homepage;
